import { render } from "./BrowserLogs.vue?vue&type=template&id=d7b837dc&scoped=true"
import script from "./BrowserLogs.vue?vue&type=script&lang=js"
export * from "./BrowserLogs.vue?vue&type=script&lang=js"

import "./BrowserLogs.vue?vue&type=style&index=0&id=d7b837dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7b837dc"]])

export default __exports__